export const START_DATE = 2
export const CUSTOM_DATE = 3
export const PERSONAL = 4
export const DUE_DATE = 6
export const OUTLOOK = 101
